import naja from "naja";

export class Ajax {
	#html
	#onAfterUpdate = []

	constructor(html, interaction = true) {
		this.#html = html

		if (interaction) {
			naja.uiHandler.addEventListener('interaction', (event) => {
				if (event.detail.element.hasAttribute('data-confirm')
					&& !window.confirm(event.detail.element.getAttribute('data-confirm'))
				) {
					event.preventDefault();
				}
			});
		}

		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			const root = document.getElementById(event.detail.snippet.id)
			this.run(root, event)
		})
	}

	onAfterUpdate(callback) {
		this.#onAfterUpdate.push(callback)

		return this
	}

	run(root, event) {
		if (typeof root === "undefined") {
			root = this.#html
		}

		for (const callback of this.#onAfterUpdate) {
			callback.call(null, root, event)
		}
	}
}
